module.exports = __webpack_public_path__ + "img/image (1).0ea9e40d.jpg";